<script lang="ts">
    import Fa from 'svelte-fa'
    import { faEdit, faTrashAlt, faCheck } from '@fortawesome/free-solid-svg-icons'
    import { createEventDispatcher, onMount } from 'svelte'
    import { ServiceNested } from '../../../modules/posApi/services/service-nested'
    import ZentitySelect from '../../_common/z/zentity-select.svelte'
    import type { Service } from '../../../modules/posApi/services/service'
    const dispatch = createEventDispatcher()

    export let item: ServiceNested = undefined

    let className: string = ''
    export { className as class }
    let step = 1
    let isNew = false
    async function editEntity() {
        step = 2
    }

    async function newEntity() {
        isNew = true
        step = 2
        item = new ServiceNested()
    }

    async function cancelEntity() {
        item = undefined
        step = 1
        dispatch('cancel')
    }

    async function confirmEntity() {
        if (!item.service) {
            window.error('Informe todas as opções antes de confirmar.')
            return
        }
        if (item.quantity <= 0) {
            window.error('Informe o valor unitário.')
            return
        }
        if (item.quantity <= 0) {
            window.error('Informe a quantidade.')
            return
        }
        item.serviceId = item.service.serviceId
        if (!item.price) item.price = 0
        dispatch('added', item)
        if (isNew) item = undefined
        step = 1
        isNew = false
    }

    onMount(() => {
        if (!item) newEntity()
    })

    function onServiceChange() {
        if (item?.service) {
            item.quantity = 1
            item.price = item.service?.price || null
        }
    }

    function friendlyName(p: Service, expiresAt: Date = null) {
        let name = p?.name || ''
        if (p?.status <= 0) name += ' (excluído)'
        return name
    }
</script>

{#if item !== undefined}
    <div class={className}>
        {#if step === 1}
            <div class="row line">
                <div class="col nowrap">{friendlyName(item.service)}</div>
                <div class="col-md-1 text-end">{window.api.utils.utils.toReal(item.price)}</div>
                <div class="col-md-1 text-end">{item.quantity}</div>
                <div class="col-md-1 text-end">{window.api.utils.utils.toReal(item.price * item.quantity) || ' -'}</div>
                <div class="col-md-2 text-end">
                    <button
                        class="btn btn-secondary btn-sm"
                        on:click={() => {
                            editEntity()
                        }}><Fa icon={faEdit} /> Editar</button
                    >
                </div>
            </div>
        {/if}
        {#if step === 2}
            <div class="row mt-2 border-bottom-0 -form">
                <div class="col ps-xl-1 pe-xl-2 mb-xl-0 space-bottom">
                    <ZentitySelect
                        label="Item"
                        fonte="servico"
                        params={{ type: 'service,product', price: true }}
                        bind:value={item.service}
                        on:change={onServiceChange}
                    />
                </div>
                <div class="col text-end ps-xl-2 pe-xl-1 width-vlr">
                    <div class="input-group input-group-sm">
                        <div class="input-group-text">Valor Unitário</div>
                        <input type="number" bind:value={item.price} class="form-control form-control-sm text-end" />
                    </div>
                </div>
                <div class="col col-md text-end ps-xl-1 pe-xl-1 width-qtde">
                    <div class="input-group input-group-sm">
                        <div class="input-group-text">Qtde</div>
                        <input type="number" bind:value={item.quantity} class="form-control form-control-sm text-end" />
                    </div>
                </div>
                <div class="col text-end ps-xl-1 pe-xl-1 width-total">
                    <div class="input-group input-group-sm">
                        <div class="input-group-text">Total</div>

                        <input type="number" value={item.price * item.quantity} class="form-control form-control-sm text-end" disabled />
                    </div>
                </div>
                <div class="col text-end ps-xl-1 btns">
                    <button class="btn btn-sm btn-warning" on:click={cancelEntity}><Fa icon={faTrashAlt} /><span class="h-full">Excluir</span></button>
                    <button class="btn btn-sm btn-primary" on:click={confirmEntity}><Fa icon={faCheck} /> Confirmar</button>
                </div>
            </div>
        {/if}
    </div>
{/if}

<style>
    .btns {
        border: 0px solid red;
        max-width: 160px;
    }
    .width-vlr {
        max-width: 200px;
    }
    .width-qtde {
        max-width: 120px;
    }
    .width-total {
        max-width: 135px;
    }
</style>
